import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFleetAdmins = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fleet-admins/lookup/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet admins fetch error:", error);
    throw error;
  }
};

const getFuelTypesOffered = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-types-offered/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel types offered fetch error:", error);
    throw error;
  }
};

const getFleetAdminVehicles = async (fleetAdminId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fleet-admins/vehicles/lookup/?id=${fleetAdminId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet admin vehicles fetch error:", error);
    throw error;
  }
};

const submitFuelDispensed = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-dispensed/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel dispensed submit error:", error);
    throw error;
  }
};

export {
  getFleetAdmins,
  getFuelTypesOffered,
  getFleetAdminVehicles,
  submitFuelDispensed,
};
